import React from "react";
import Marquee from "react-fast-marquee";
import { COURSES } from "../../config/site";

export const CourseMarquee = () => {
  return (
    <div className="border-y border-white/10 bg-slate-900/40 py-5" data-testid="course-marquee">
      <Marquee speed={28} gradient={false} autoFill>
        {COURSES.map((c) => (
          <span key={c.id} className="mx-8 label-mono text-slate-400 flex items-center gap-8">
            {c.name}
            <span className="text-slate-700">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
